import React from 'react';
import ReactDOM from 'react-dom';
import { debounce } from 'lodash';
import { nanoid } from 'nanoid';
import { NodeSelection, Plugin, PluginKey } from 'prosemirror-state';

import { BaseExtension, EditorOptions, extensionType } from '@lyearn/lygo-core';

import { getElementPos, removeMenuContainer, setPluginMeta } from '../../utils';
import { displayReplaceMenuItem } from '../BlockMenu/utils/actions';
import { BLOCK_DOTTED_LINE_POPPER_ID, BlockMenuButtonComponent } from './BlockMenuButton';
import {
  getBlockElmentOnHover,
  getBlockMenuButtonDefaultProps,
  isBlockmenuOpen,
  showBlockMenuButton,
} from './utils';
import VerticalDashedLine from './VerticalDashedLine';

export const blockDottedLinekey = new PluginKey('block-dotted-line-plugin');

const BLOCK_DOTTED_LINE_CONTAINER_ID = 'block-dotted-line-container';

export default class BlockDottedLine extends BaseExtension {
  get type(): string {
    return extensionType.toolbar;
  }

  get name(): string {
    return 'block_dotted_line';
  }

  plugins({ portalApi, isLocalizedContent, isMicroLearning }: EditorOptions) {
    return [
      new Plugin({
        key: blockDottedLinekey,
        state: {
          init() {
            return getBlockMenuButtonDefaultProps(isLocalizedContent);
          },
          apply(tr, old) {
            const props = tr.getMeta(blockDottedLinekey);
            return props || old;
          },
        },
        view: (editorView) => {
          let previousHeight = 0;
          let previousPoints: number[] = [];
          // This will be called only once. It will add a container div.
          // Block Menu Button will be rendered in this container div.
          // let blockDottedLineContainer = document.createElement('div');
          // blockDottedLineContainer.id = BLOCK_DOTTED_LINE_CONTAINER_ID;
          // blockDottedLineContainer.style.backgroundColor = 'green';
          // blockDottedLineContainer.style.width = '2px';
          // blockDottedLineContainer.style.height = '2px';
          // editorView?.dom?.parentNode?.appendChild(blockDottedLineContainer);

          const portalKey = nanoid();
          // Need to return the following functions in the view function
          return {
            update: (view) => {
              if (!isMicroLearning) return null;
              // return; // WILL SOLVE IT LATER ( TODO: Check mark rendering issue  sometimes getting drifted to bottom .  )
              const state = view.state;
              let props = blockDottedLinekey.getState(state);
              props.view = view;
              // const lineContainerEl = editorView?.dom?.parentNode?.querySelector(
              //   `#${BLOCK_DOTTED_LINE_CONTAINER_ID}`,
              // );

              const parentNodeOfEditor = editorView?.dom?.parentNode as HTMLElement;
              // console.log(props, 'props-this-is-props');
              // console.log(editorView?.dom?.parentNode, 'editorView?.dom?.parentNode');
              // const childrenArray = Array.from(parent.children);
              // console.log('editorView?.dom', 'editorView?.dom', editorView?.dom);

              const editorEl = editorView?.dom;

              // const currentHeight = editorEl.offsetHeight;

              // const parentRect = editorEl.getBoundingClientRect();
              // const domRect = parentEl?.getBoundingClientRect();

              // Calculate offset from dom container to parent
              // const lineContainerTop = lineContainerEl?.getBoundingClientRect().top ?? 0;
              const parentNodeOfEditorTop = parentNodeOfEditor?.getBoundingClientRect().top ?? 0;

              const height = editorEl.offsetHeight;

              const hasZeroSizedBlock = Array.from(editorEl.children).some(
                (child: any) => child.offsetHeight == 0,
              );
              if (hasZeroSizedBlock) {
                return;
              }
              const checkpoints =
                Array.from(editorEl.children).map((child: any) => {
                  const cordinate = child?.getBoundingClientRect().top + child.offsetHeight / 2;

                  return cordinate - parentNodeOfEditorTop - 25;
                }) ?? [];
              const pointsAreSame =
                previousPoints.length === checkpoints.length &&
                previousPoints.every((p, i) => p === checkpoints[i]);

              if (height === previousHeight && pointsAreSame) {
                return; //  No change, skip rendering
              }

              previousHeight = height;
              previousPoints = checkpoints;

              if (
                parentNodeOfEditor &&
                editorEl &&
                // checkpoints?.length > 1 &&
                checkpoints[0] >= 0
              ) {
                const height = editorEl.offsetHeight;
                parentNodeOfEditor.style.position = 'relative';
                // console.log(checkpoints, 'checkpoints=checkpoints=checkpoints', top);
                const line = (
                  <div
                    key={new Date().getTime()}
                    style={{
                      position: 'absolute',
                      top: `${0}px`,
                      left: '-100px',
                      transform: 'translateY(20px)',
                      height: `${height}px`,
                      pointerEvents: 'none',
                    }}>
                    <VerticalDashedLine height={height} points={checkpoints} />
                  </div>
                );

                portalApi.createPortal(ReactDOM.createPortal(line, parentNodeOfEditor, portalKey));
              }
            },
            destroy: () => {
              portalApi.destroyPortal(portalKey);
              // removeMenuContainer(BLOCK_DOTTED_LINE_CONTAINER_ID, editorView);
            },
          };
        },

        props: {
          handleDOMEvents: {
            mouseover: (editorView, event) => {
              if (isBlockmenuOpen(editorView)) {
                return false;
              }
              const ele = getBlockElmentOnHover(event.target);
              let props = {
                open: false,
                anchorEl: null,
                isLocalizedContent,
              };
              if (ele) {
                props.open = true;
                props.anchorEl = ele;
              }
              setPluginMeta(editorView, blockDottedLinekey, props);
              return false;
            },
          },
        },
      }),
    ];
  }
}
